import React from "react";
import BaseWineSearchBar from "../../../components/global/SearchBar/BaseWineSearchBar";
import WineDetail from "../../../components/global/Wines/WineDetail";
import Header from "../../../components/layout/Header/Header";
import Layout from "../../../components/layout/Layout/Layout";
import { getBaseWine } from "../../../lib/wineRequests";
import { withUserSSR } from "../../../utils/withUserSSR";

export default function WineVintagePage({ baseWine, vintage, error, user }) {
  return (
    <Layout>
      <Header />
      <BaseWineSearchBar className="pb-8" hideResults={true} />
      <WineDetail baseWine={baseWine} vintage={vintage} error={error}/>
    </Layout>
  );
}

export const getServerSideProps = withUserSSR(async (context) => {
  try {
    const { slug } = context.params;
    const { vintage, wineId } = context.query;
    // Forward the visitor's session so subscribers get full tasting notes.
    const cookie = context.req.headers.cookie || "";

    const { data } = wineId ? await getBaseWine(slug as string, null, +wineId, cookie) : await getBaseWine(slug as string, undefined, undefined, cookie);

    const vintageExists = data.wines.some(value => value.wine.vintage === parseInt(vintage[0]));
    
    if (!vintageExists && vintage.length > 0) {
      return {
        props: {
          error: `Unable to load Wine Reviews for vintage ${vintage[0]}`,
        }
      };
    }

    return {
      props: {
        baseWine: data,
        vintage: vintage ? parseInt(vintage[0]) : null
      },
    };
  } catch (error) {
    const { slug } = context.params;
    const { vintage } = context.query;
    let errorMessage = "Failed to fetch base wine data";

    if (error.status === 404) {
      errorMessage = vintage && vintage.length > 0
        ? `Unable to load Wine Reviews for vintage ${vintage[0]}`
        : `Unable to load Wine Reviews for slug ${slug}`;
    }

    return {
      props: {
        error: errorMessage,
      }
    };
  }
});
